import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ActionCreators from '../actions';
import OutreachAdd from '../components/Outreach/AddCampaign';

function mapDispatchToProps(dispatch) {
  return bindActionCreators(ActionCreators, dispatch);
}

function mapStateToProps(state) {
  return {
    outreach: state.Outreaches,
    business: state.business,
    auth:state.auth,
    carriers: state.carriers,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(OutreachAdd);
